// extracted by mini-css-extract-plugin
module.exports = {"brickRowContainer":"styles_brickRowContainer__1IG3d","brickRow":"styles_brickRow__2By1D"};